import CompaniesLoading from '@/features/companies/loading'
import CompaniesPage from '@/features/companies/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/companies/')({
  component: CompaniesPage,
  pendingComponent: CompaniesLoading,
})
